import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { View } from 'react-native'
import { FlatList } from 'react-native-gesture-handler'
import { PressableOpacity } from 'shared/components/pressable_opacity'

export interface FilterItem {
  id: number
  name: FilterItemName
}

type FilterItemName =
  | 'all'
  | 'documents'
  | 'folders'
  | 'photosVideos'
  | 'webLinks'

const filterItemNames: FilterItemName[] = [
  'all',
  'documents',
  'folders',
  'photosVideos',
  'webLinks',
]

export const FILTER_ITEMS: {
  [key in FilterItemName]: { id: number; name: FilterItemName }
} = filterItemNames.reduce((acc, name, index) => {
  acc[name] = { id: index, name }
  return acc
}, {} as { [key in FilterItemName]: { id: number; name: FilterItemName } })

export const getFilterItems = (isFilesGroup: boolean) => {
  if (isFilesGroup) {
    return [
      FILTER_ITEMS.all,
      FILTER_ITEMS.documents,
      FILTER_ITEMS.folders,
      FILTER_ITEMS.photosVideos,
      FILTER_ITEMS.webLinks,
    ]
  } else {
    return [
      FILTER_ITEMS.all,
      FILTER_ITEMS.documents,
      FILTER_ITEMS.photosVideos,
      FILTER_ITEMS.webLinks,
    ]
  }
}

interface Props {
  items: FilterItem[]
  selectedIndex: number
  onSelect: (index: number) => void
}
export function FiltersRow({ items, onSelect, selectedIndex }: Props) {
  return (
    <View>
      <FlatList
        keyboardShouldPersistTaps="handled"
        horizontal
        data={items}
        showsHorizontalScrollIndicator={false}
        keyExtractor={item => item.id.toString()}
        renderItem={({ item }) => (
          <FilterRowItem
            item={item}
            onPress={() => onSelect(item.id)}
            isSelected={item.id === selectedIndex}
          />
        )}
      />
    </View>
  )
}

const FilterRowItem = ({
  item,
  onPress,
  isSelected,
}: {
  item: FilterItem
  onPress: () => void
  isSelected: boolean
}) => {
  const styles = useStyles()
  return (
    <PressableOpacity onPress={onPress}>
      <View
        style={[
          styles.filterItemContainer,
          isSelected ? styles.selectedFilterItemContainer : {},
        ]}
      >
        <Text
          style={[
            styles.filterItemText,
            isSelected ? styles.selectedFilterItemText : {},
          ]}
        >
          {t(item.name)}
        </Text>
      </View>
    </PressableOpacity>
  )
}

const useStyles = makeStyles(theme => ({
  filterItemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 8,
    borderRadius: 15,
    backgroundColor:
      theme.mode === 'dark' ? theme.colors.grey11 : theme.colors.grey6,
    marginHorizontal: 4,
    borderWidth: 1,
    borderColor: theme.colors.white,
    marginBottom: 5,
  },
  filterItemText: {
    color: theme.colors.black,
  },
  selectedFilterItemContainer: {
    borderWidth: 1,
    borderColor: theme.colors.primary,
    borderRadius: 15,
    backgroundColor: theme.colors.primary,
  },
  selectedFilterItemText: {
    color: theme.colors.white,
  },
}))
